<template>
  <div style="padding: 10px 10px 10px 0">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <!-- <el-form-item label="新悦合同编号">
				<el-input v-model="formInline.contractCode" placeholder="合同编号" style="width: 160px;"></el-input>
			</el-form-item> -->

      <el-form-item label="商铺编号">
        <!-- <el-input size="small"  clearable v-model="formInline.shopCode" placeholder="商铺编号" style="width: 130px;"></el-input> -->
        <el-select
          filterable
          size="small"
          v-model="formInline.shopCode"
          placeholder="请选择商铺号"
          clearable
          style="width: 130px"
        >
          <el-option
            v-for="item in uniqueShopNumList"
            :label="item.shopCode"
            :value="item.shopCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户名称">
        <!-- <el-input size="small" clearable v-model="formInline.merchantName" placeholder="商户名称"
					style="width: 200px;"></el-input> -->
        <el-select
          filterable
          size="small"
          v-model="formInline.merchantName"
          placeholder="请选择商铺名称"
          clearable
          style="width: 240px"
        >
          <el-option
            v-for="item in uniqueShopList"
            :label="item.merchantName"
            :value="item.merchantName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经营品牌">
        <!-- <el-input size="small" clearable v-model="formInline.brandName" placeholder="经营品牌"
					style="width: 130px;"></el-input> -->
        <el-select
          filterable
          size="small"
          v-model="formInline.brandName"
          placeholder="请选择经营品牌"
          clearable
          style="width: 200px"
        >
          <el-option
            v-for="item in uniqueShopList"
            :label="item.brandName"
            :value="item.brandName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否补充协议">
        <el-select
          size="small"
          v-model="formInline.isAgreement"
          placeholder="请选择是否补充协议"
          style="width: 130px"
          clearable
        >
          <el-option label="否" value="0"></el-option>
          <el-option label="是" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合同状态">
        <el-select
          size="small"
          clearable
          v-model="formInline.status"
          placeholder="合同状态"
          style="width: 130px"
        >
          <el-option label="启用" value="启用"></el-option>
          <el-option label="禁用" value="禁用"></el-option>
          <!-- <el-option label="删除" value="删除"></el-option>
          <el-option label="终止" value="终止"></el-option> -->
          <!-- <el-option label="删除" value="2"></el-option>
					<el-option label="终止" value="3"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select
          size="small"
          clearable
          v-model="formInline.result"
          placeholder="合同状态"
          style="width: 130px"
        >
          <el-option label="审核中" value="审核中"></el-option>
          <el-option label="审核通过" value="同意"></el-option>
          <el-option label="退回" value="退回"></el-option>
          <!-- <el-option label="删除" value="2"></el-option>-->
          <el-option label="停用" value="停用"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="租金收缴方式">
        <el-select
          size="small"
          clearable
          v-model="formInline.rentType"
          placeholder="请选择"
          style="width: 130px"
        >
          <el-option label="固定租金" value="固定租金"></el-option>
          <el-option label="提成租金" value="提成租金"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
          size="small"
          v-model="formInline.beginDate"
          type="date"
          placeholder="选择日期"
          style="width: 160px"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          size="small"
          v-model="formInline.endDate"
          type="date"
          placeholder="选择日期"
          style="width: 160px"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="query()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="addBtu()">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="addTemplate"
          >下载导入模板</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-upload
          action="/api/admin/newContract/importNewZsContract"
          name="file"
          :show-file-list="false"
          :headers="headers"
          :on-success="success"
          :on-error="error"
        >
          <el-button size="small" type="primary" v-hasPermi="['biz:contract:import']"
            >导入</el-button
          >
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-upload
          action="/api/admin/newContract/importAgreement"
          name="file"
          :show-file-list="false"
          :headers="headers"
          :on-success="success"
          :on-error="error"
        >
          <el-button size="small" type="primary" v-hasPermi="['biz:contract:import']"
            >补充协议导入</el-button
          >
        </el-upload>
      </el-form-item>
      <!-- <el-form-item>
				<el-button type="primary" @click="drsm = true">导入说明</el-button>
			</el-form-item> -->
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          @click="exportData"
          v-hasPermi="['biz:contract:export']"
          >导出</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-popover
          placement="bottom"
          width="200"
          v-model="show2"
          style="margin-bottom: 20px"
        >
          <el-checkbox-group v-model="checkList" @change="checkChange">
            <el-checkbox
              :label="val"
              v-for="(val, key) in oldTitleObj"
              :key="key"
              :disabled="val == oneRow"
            >
            </el-checkbox>
          </el-checkbox-group>
          <el-button slot="reference" size="small" type="primary">筛选列表</el-button>
        </el-popover>
      </el-form-item>
    </el-form>
    <el-table
      :data="data"
      style="width: 100%"
      border
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column
        v-for="(val, key, index) in titleObj"
        :prop="key"
        :label="val"
        align="center"
        v-if="key != `is`"
      >
      </el-table-column>
      <!-- 			<el-table-column prop="contractCode" label="合同编号"></el-table-column>
			<el-table-column prop="merchantName" label="商户名称"></el-table-column>
			<el-table-column prop="shopCode" label="商铺编号"></el-table-column>
			<el-table-column prop="brandName" label="名称"></el-table-column>
			<el-table-column prop="beginDate" label="开始日期">

			</el-table-column>
			<el-table-column prop="endDate" label="到期时间">

			</el-table-column>
			<el-table-column prop="rentalArea" label="出租面积"></el-table-column>
			<el-table-column prop="shopFormat" label="经营业态"></el-table-column>
			<el-table-column prop="decoFreeRentBegin" label="装修免租期开始时间"></el-table-column>
			<el-table-column prop="decorationFreeRent" label="装修免租期结束时间"></el-table-column>
			<el-table-column prop="openFreeRentBegin" label="经营免租期开始时间"></el-table-column>
			<el-table-column prop="openFreeRent" label="经营免租期结束时间"></el-table-column>
			<el-table-column prop="openDate" label="开业时间"></el-table-column>
			<el-table-column prop="createTime" label="创建时间"></el-table-column>
			<el-table-column prop="status" label="合同状态">
			
			</el-table-column> -->
      <el-table-column prop="isAgreement" label="是否补充协议">
        <template slot-scope="{ row }">
          <span>{{ row.isAgreement == 0 ? "否" : "是" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date" width="200" label="操作">
        <template slot-scope="{ row }">
          <el-button type="text" @click="ckRow(row)">查看</el-button>
          <el-button
            type="text"
            v-if="row.result == '审核中'"
            @click="shRow(row)"
            v-hasPermi="['biz:contract:check']"
            >审核</el-button
          >
          <!-- v-if="row.result == '审核中'" -->
          <el-button
            type="text"
            v-if="row.result == '审核中'"
            @click="setRow(row)"
            v-hasPermi="['biz:contract:update']"
            >修改</el-button
          >
          <el-button
            type="text"
            v-if="row.result == '审核中'"
            @click="delRow(row)"
            v-hasPermi="['biz:contract:remove']"
            >删除</el-button
          >
          <el-button
            type="text"
            v-if="row.result == '同意' && row.rentType == '提成租金'"
            :style="mindUnput(row)"
            @click="viewSalesVolume(row)"
            >租金录入</el-button
          >

          <el-button type="text" v-if="row.result == '同意'" @click="ty2(row)"
            >停用</el-button
          >

          <!--el-button type="text" v-if="row.result=='审核中'&&roleId==5" @click="shRow(row)">审核</el-button>
					<el-button type="text" v-if="row.result=='审核中'&&roleId==5" @click="setRow(row)">修改</el-button>
					<el-button type="text" v-if="row.result=='审核中'&&roleId==5" @click="delRow(row)">删除</el-button-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :page-sizes="[10, 20, 30, 40]"
      :current-page.sync="formInline.page"
      :page-size="formInline.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-dialog title="导入说明" :visible.sync="drsm">
      <div>
        1.合同号由新悦公司生成的；合同编号是人才公司内部合同编号，需录入，不能为空。
      </div>
      <div>2.合同状态：启用、禁用、删除、终止</div>
      <div>
        3.租金收取方式：固定租金、提成租金；固定租金提成比例默认为0；提成租金比例需录入百分比，例如15%，租金填0，后期系统根据每月录入的营业额计算租金。
      </div>
      <div>
        4.经营免租期:经营免租期通常情况下只有一行记录
        格式为：2021-10-31/2021-11-31，起始时间/结束时间；多个免租期间时，用英文逗号（,）隔开
      </div>
      <div>5.除合同附件可不填，其他均为必填项</div>
      <div>6.时间格式均为 年-月-日，以横杆为间隔，例如 2022-1-1</div>
    </el-dialog>
    <el-dialog :title="titleShow" :visible.sync="show" width="950px">
      <div style="height: auto; overflow: auto">
        <el-form :model="info" class="demo-form-inline">
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否是补充协议：" label-width="160px">
                <el-select
                  v-model="info.isAgreement"
                  placeholder="是否是补充协议"
                  style="width: 130px"
                >
                  <el-option label="否" value="0"></el-option>
                  <el-option label="是" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="新悦合同编号：" label-width="160px">
                <el-input
                  :disabled="isSh"
                  v-model="info.contractCode"
                  placeholder="新悦合同编号"
                ></el-input>
                <!-- <span :disabled="true">{{ info.contractCode }}</span> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开业时间：" label-width="160px">
                <!-- <span>{{ info.openDate }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.openDate"
                  placeholder="开业时间"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同编号：" label-width="160px">
                <!-- <span>{{ info.contractInCode }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.contractInCode"
                  placeholder="合同编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="审核状态：" label-width="160px">
                <!-- <span>{{ info.result }}</span> -->
                <el-select
                  :disabled="true"
                  v-model="info.result"
                  placeholder="审核状态"
                  style="width: 130px"
                >
                  <el-option label="已审核" value="同意"></el-option>
                  <el-option label="未审核" value="未审核"></el-option>
                  <el-option label="退回" value="退回"></el-option>
                  <el-option label="停用" value="停用"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同状态：" label-width="160px">
                <!-- <span>{{ info.status }}</span> -->
                <el-select
                  :disabled="isSh"
                  v-model="info.status"
                  placeholder="合同状态"
                  style="width: 130px"
                >
                  <el-option label="启用" value="启用"></el-option>
                  <el-option label="禁用" value="禁用"></el-option>
                  <el-option label="删除" value="删除"></el-option>
                  <el-option label="终止" value="终止"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="装修期物业费(元)：" label-width="160px">
                <!-- <span>{{ info.decorationPropertyFee }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.decorationPropertyFee"
                  placeholder="装修期物业费(元)"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="商户名称：" label-width="160px">
                <!-- <span>{{ info.merchantName }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.merchantName"
                  placeholder="商户名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="装修保证金(元)：" label-width="160px">
                <!-- <span>{{ info.decorationDeposit }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.decorationDeposit"
                  placeholder="装修保证金(元)"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="商铺编号：" label-width="160px">
                <!-- <span>{{ info.shopCode }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.shopCode"
                  placeholder="商铺编号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="租金收取方式：" label-width="160px">
                <!-- <span>{{ info.rentType }}</span> -->
                <div style="style: flex">
                  <el-select
                    :disabled="isSh"
                    v-model="info.rentType"
                    placeholder="租金收取方式"
                  >
                    <el-option label="固定租金" value="固定租金"></el-option>
                    <el-option label="提成租金" value="提成租金"></el-option>
                  </el-select>
                  <el-checkbox
                    v-if="info.rentType == '固定租金'"
                    :disabled="isSh"
                    v-model="rentTypeChange"
                    style="margin-left: 10px"
                    >每年变化</el-checkbox
                  >
                </div>
                <div>
                  <!-- <el-button size="mini" v-if="info.rentType == '提成租金'" type="primary"
									@click="innerVisible = true">提成比例</el-button> -->
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <!-- <div style="color: red;">*说明：</div>
									1、营业额的区间关系是 ：最小金额
									< 营业额 <=最大金额；<br />
									2、营业额没有区间则金额全部填0；<br />
									3、提成比例录入小数点后两位，例如：0.03<br />
									4、每年分别单独保存
								</div> -->
              <el-form-item label="租金：" label-width="160px">
                <div v-if="info.rentType == '固定租金'">
                  <div v-if="rentTypeChange">
                    <div style="color: red">
                      <div>
                        示例1：第1年：8元/平/天；第2年：8元/平/天；第3年：8.4元/平/天；第4年：8.4元/平/天<br>
                        示例2：第0.5年：8元/平/天；第1年：8元/平/天；第1.5年：8.4元/平/天；第2年：8.4元/平/天
                      </div>
                      <div>所有符号均为中文符号</div>
                    </div>
                    <el-input
                      :disabled="isSh"
                      v-model="info.deadRent"
                      type="textarea"
                      :rows="2"
                      placeholder="请输入"
                      
                    >
                    </el-input>
                  </div>
                  <div v-else>
                    <div style="color: red">
                      <div>填入固定数字，如若每年变化请先勾选每年变化再输入</div>
                    </div>
                    <el-input
                      :disabled="isSh"
                      style="width: 100px"
                      v-model="info.rent"
                      placeholder="请输入"
                    >
                    </el-input
                    ><span style="margin-left: 10px">元/天</span>
                  </div>
                </div>
                <div v-if="info.rentType == '提成租金'">
                  <div style="color: red">
                    <div>示例1：年：<=400万，3%；<400万&&<=700万，8%；>700万，9%</div>
                    <div>示例2：月：<=25万，0%；<25万&&<=50万，5%；>50万，7%</div>
                    <div>
                      示例3：第1-第3年：11%#第4年：12%#第5-6年：12%#第7年：13%#第8年：14%
                    </div>
                    <div>
                      示例4：第1年：<=400万,0%；<400万&&<=700万，8%；>700万，9%#第2年：
                      <=400万,0%；<400万&&<=700万，8%；>700万，9%#其他：<=400万，3%；<400万&&<=700万，8%；>
                      700万，9%
                    </div>
                    <div>***所有符号均为中文符号</div>
                  </div>
                  <el-input
                    :disabled="isSh"
                    v-model="info.commissionPercentage"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入"
                  >
                  </el-input>
                </div>

                <!-- <span>{{
								info.commissionPercentage != 0 && info.commissionPercentage ? info.commissionPercentage
									:
									info.rent + '元/天'
							}}</span> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="租金付款周期(自然月)：" label-width="165px">
                <!-- <span>{{ info.paymentCycleRent }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.paymentCycleRent"
                  placeholder="租金付款周期"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="经营业态：" label-width="160px">
                <!-- <span>{{ info.shopFormat }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.shopFormat"
                  placeholder="经营业态"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="经营品牌：" label-width="160px">
                <!-- <span>{{ info.brandName }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.brandName"
                  placeholder="经营品牌"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="'物业费(元/㎡*' + wuTitle + ')：'"
                label-width="160px"
              >
                <div style="display: flex">
                  <!-- <span>{{ info.propertyFee }}</span> -->
                  <el-input
                    style="width: 100px"
                    :disabled="isSh"
                    v-model="info.propertyFee"
                    placeholder="物业费"
                  ></el-input>
                  <el-checkbox
                    :disabled="isSh"
                    v-model="propertyFeeType"
                    style="margin-left: 10px"
                    >/月</el-checkbox
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="物业付款周期(自然月)：" label-width="165px">
                <!-- <span>{{ info.paymentCycleWuye }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.paymentCycleWuye"
                  placeholder="物业付款周期"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同计租日：" label-width="160px">
                <!-- <span>{{ info.rentBeginDate }}</span> -->
                <el-date-picker
                  :disabled="isSh"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="合同计租日"
                  v-model="info.rentBeginDate"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="合同交付日：" label-width="160px">
                <!-- <span>{{ info.deliveryDate }}</span> -->
                <el-date-picker
                  :disabled="isSh"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="合同交付日"
                  v-model="info.deliveryDate"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="出租面积：" label-width="160px">
                <!-- <span>{{ info.rentalArea }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.rentalArea"
                  placeholder="出租面积"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="推广费(元/㎡*月)：" label-width="160px">
                <!-- <span>{{ info.promotionFee }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.promotionFee"
                  placeholder="推广费"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="开始日期：" label-width="160px">
                <!-- <span>{{ info.beginDate }}</span> -->
                <el-date-picker
                  :disabled="isSh"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="开始日期"
                  v-model="info.beginDate"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束日期：" label-width="160px">
                <!-- <span>{{ info.endDate }}</span> -->
                <el-date-picker
                  :disabled="isSh"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="结束日期"
                  v-model="info.endDate"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="履约保证金(元)：" label-width="160px">
                <!-- <span>{{ info.performanceBond }}</span> -->
                <el-input
                  :disabled="isSh"
                  v-model="info.performanceBond"
                  placeholder="履约保证金"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
							<el-form-item label="合同计租日：" label-width="160px">
								<el-date-picker :disabled="isSh" value-format="yyyy-MM-dd" type="date"
									placeholder="合同计租日" v-model="info.rentBeginDate"
									style="width: 100%;"></el-date-picker>
							</el-form-item>
						</el-col> -->
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="装修免租期开始时间：" label-width="160px">
                <!-- <span>{{ info.decoFreeRentBegin }}</span> -->
                <el-date-picker
                  :disabled="isSh"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="装修免租期开始时间"
                  v-model="info.decoFreeRentBegin"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="装修免租截止日期：" label-width="160px">
                <!-- <span>{{ info.decorationFreeRent }}</span> -->
                <el-date-picker
                  :disabled="isSh"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="装修免租截止日期"
                  v-model="info.decorationFreeRent"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button
              @click="addJYMZQ"
              style="margin-left: 30px"
              type="primary"
              size="mini"
              >添加经营免租期</el-button
            >
            <el-button
              v-if="openFreeRentTime.length > 0"
              @click="delJYMZQ"
              style="margin-left: 10px"
              type="primary"
              size="mini"
              >减少经营免租期</el-button
            >
          </el-form-item>
          <el-col :span="12" v-for="(item, index) in openFreeRentTime" :key="index">
            <el-form-item :label="`经营免租期${index + 1}：`" label-width="160px">
              <el-date-picker
                :disabled="isSh"
                type="daterange"
                placeholder="经营免租期"
                v-model="item.dateValue"
                style="width: 100%"
                value-format="timestamp"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- (全免:1 减半:0.5) -->
          <!-- <el-col :span="12">
						<el-form-item label="免租率：" label-width="160px">
						
							<el-select style="width:100%;" :disabled="isSh" v-model="info.freeRentRatio"
								placeholder="请选择免租率">
								<el-option v-for="item in freeRentRatioList" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
          <!-- </el-row> -->
          <el-col :span="12">
            <el-form-item label="发票抬头：" label-width="160px">
              <el-input
                :disabled="isSh"
                v-model="info.invoiceHand"
                placeholder="发票抬头"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纳税人识别号：" label-width="160px">
              <el-input
                :disabled="isSh"
                v-model="info.dutyParagraph"
                placeholder="纳税人识别号"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="单位地址：" label-width="160px">
              <el-input
                :disabled="isSh"
                v-model="info.address"
                placeholder="单位地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话：" label-width="160px">
              <el-input
                :disabled="isSh"
                v-model="info.phone"
                placeholder="电话"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户银行：" label-width="160px">
              <el-input
                :disabled="isSh"
                v-model="info.bankName"
                placeholder="开户银行"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账号：" label-width="160px">
              <el-input
                :disabled="isSh"
                v-model="info.bankAccount"
                placeholder="银行账号"
              ></el-input>
            </el-form-item>
          </el-col>
          <!--<el-row>
				 <el-col :span="12">
						<el-form-item label="经营免租期截止日期" label-width="160px">
							<el-date-picker :disabled="isSh" type="date" placeholder="经营免租期截止日期"
								v-model="info.openFreeRent" style="width: 100%;"></el-date-picker>
						</el-form-item>

					</el-col> -->

          <el-col :span="12">
            <el-form-item label="联系人" label-width="160px">
              <el-input
                :disabled="isSh"
                v-model="info.person"
                placeholder="联系人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" label-width="160px">
              <el-input
                :disabled="isSh"
                v-model="info.personPhone"
                placeholder="联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-row>
					<el-col :span="24">
						<el-form-item label="备注" label-width="160px">
							<el-input :disabled="isSh" v-model="info.flag" placeholder="备注"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
        </el-form>
      </div>
      <span v-if="!isSh && !isCK" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ok">确定</el-button>
        <el-button @click="show = false">取 消</el-button>
      </span>
      <span v-if="isSh && !isCK" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ty('退回')">退 回</el-button>
        <el-button type="primary" @click="ty('同意')">同 意</el-button>
        <el-button @click="show = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="以下数据存在问题" :visible.sync="isFail">
      <div style="margin-bottom: 30px">
        <h3>已经存在的记录</h3>
        <el-table :data="czList" style="width: 100%" border>
          <el-table-column prop="contractCode" label="合同编号"></el-table-column>
          <el-table-column prop="merchantName" label="商户名称"></el-table-column>
          <el-table-column prop="shopCode" label="商铺编号"></el-table-column>
          <el-table-column prop="brandName" label="名称"></el-table-column>
          <el-table-column prop="beginDate" label="开始日期"> </el-table-column>
          <el-table-column prop="endDate" label="到期时间"> </el-table-column>
          <el-table-column prop="rentalArea" label="出租面积"></el-table-column>
          <el-table-column prop="shopFormat" label="经营业态"></el-table-column>
          <el-table-column
            prop="decoFreeRentBegin"
            label="装修免租期开始时间"
          ></el-table-column>
          <el-table-column
            prop="decorationFreeRent"
            label="装修免租期结束时间"
          ></el-table-column>
          <el-table-column
            prop="openFreeRentBegin"
            label="经营免租期开始时间"
          ></el-table-column>
          <el-table-column
            prop="openFreeRent"
            label="经营免租期结束时间"
          ></el-table-column>
          <el-table-column prop="openDate" label="开业时间"></el-table-column>
          <!-- <el-table-column prop="createTime" label="创建时间"></el-table-column> -->
          <el-table-column prop="status" label="合同状态"> </el-table-column>
          <!-- <el-table-column prop="flag" label="备注"></el-table-column> -->
          <el-table-column prop="invoiceHand" label="发票抬头"></el-table-column>
          <el-table-column prop="dutyParagraph" label="纳税人识别号"></el-table-column>
          <el-table-column prop="result" label="审核状态"></el-table-column>
        </el-table>
      </div>
      <div>
        <h3>缺失字段记录</h3>
        <el-table :data="qsList" style="width: 100%" border>
          <el-table-column prop="contractCode" label="合同编号"></el-table-column>
          <el-table-column prop="merchantName" label="商户名称"></el-table-column>
          <el-table-column prop="shopCode" label="商铺编号"></el-table-column>
          <el-table-column prop="brandName" label="名称"></el-table-column>
          <el-table-column prop="beginDate" label="开始日期"> </el-table-column>
          <el-table-column prop="endDate" label="到期时间"> </el-table-column>
          <el-table-column prop="rentalArea" label="出租面积"></el-table-column>
          <el-table-column prop="shopFormat" label="经营业态"></el-table-column>
          <el-table-column
            prop="decoFreeRentBegin"
            label="装修免租期开始时间"
          ></el-table-column>
          <el-table-column
            prop="decorationFreeRent"
            label="装修免租期结束时间"
          ></el-table-column>
          <el-table-column prop="openFreeRentTime" label="经营免租期"></el-table-column>
          <!-- <el-table-column prop="openFreeRentBegin" label="经营免租期开始时间"></el-table-column>
					<el-table-column prop="openFreeRent" label="经营免租期结束时间"></el-table-column> -->
          <el-table-column prop="openDate" label="开业时间"></el-table-column>
          <!-- <el-table-column prop="createTime" label="创建时间"></el-table-column> -->
          <el-table-column prop="status" label="合同状态"></el-table-column>
          <!-- <el-table-column prop="flag" label="备注"></el-table-column> -->
          <el-table-column prop="invoiceHand" label="发票抬头"></el-table-column>
          <el-table-column prop="dutyParagraph" label="纳税人识别号"></el-table-column>
          <el-table-column prop="result" label="审核状态"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :title="'租金录入'" :visible.sync="rentTypShow" width="800px">
      <div style="margin-bottom: 10px">
        <!-- <div>提成比例</div>
				<div style="margin-left: 20px;">
					<span>租金年份：</span>
					<el-select v-model="yearNow" placeholder="请选择租金年份" size="small">
						<el-option v-for="item in yearList" :label="item.year" :value="item.id"></el-option>
					</el-select>
				</div> -->
        <div>商户名称：{{ info.merchantName }}</div>
        <div>提成备注：{{ info.flag }}</div>

        <!-- <div style="margin-top:10px;">{{ info.commissionPercentage }}</div> -->
      </div>
      <div>
        <div>租金计算规则：</div>
        <el-radio
          style="margin-top: 10px"
          v-for="item in commissionPercentageListNew"
          v-model="radio"
          :label="item"
          >{{ item }}</el-radio
        >
      </div>

      <div style="margin-top: 15px">
        <el-form :inline="true" :model="formRent" class="demo-form-inline">
          <el-form-item label="选择时间">
            <el-date-picker
              size="small"
              v-model="salesDate"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="handleDateChange" 
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="营业额">
            <el-input
              size="small"
              @input="(v) => (formRent.num = v.replace(/[^\d.]/g, ''))"
              v-model="formRent.num"
              @change="changeNum"
              placeholder="请输入营业额"
            ></el-input>
          </el-form-item>
          <el-form-item label="租金">
            <el-input
              size="small"
              v-model="formRent.money"
              placeholder="请输入租金"
            ></el-input>
          </el-form-item>     
          <el-form-item label="附件上传">
            <el-upload
              class="upload-demo"
              action="/api/admin/dutyInfo/uploadFile"
              name="file"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :headers="headerData"
              :on-success="onSuccess"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>

            <div
              v-for="(item, index) in fileList"
              :key="index"
              style="
                color: #3c98ff;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
              "
            >
              <div @click="down(item.name, item.url)">{{ item.name }}</div>
              <div @click="delUrl(index)"><i class="el-icon-delete"></i></div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="rentSubmit()">保存</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div>历史记录</div>
      <el-table :data="historyData" style="width: 100%">
        <el-table-column prop="salesDate" label="租金月份" align="center" />
        <el-table-column prop="num" label="营业额" align="center" />
        <el-table-column prop="money" label="租金金额" align="center" />
        <el-table-column prop="updateName" label="录入人" align="center" />
        <el-table-column prop="createTime" label="录入时间" align="center" />
        <el-table-column prop="accessoryName" label="附件" align="center">
          <template slot-scope="scope">
            <div
              @click="down(item.name, item.url)"
              v-for="item in scope.row.fileList"
              style="color: #3c98ff; cursor: pointer"
            >
              {{ item.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="delRentType(scope.$index, scope.row)"
              type="text"
              size="text"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="rentTypShow = false">取 消</el-button> -->
        <el-button @click="rentTypShow = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import publicExport from "../../assets/js/publicExport.js";
import downloadFile from "../../assets/js/downloadFile.js";
export default {
  data() {
    return {
      shopList: [],
      shopListSelect:[],
      fileList: [],
      fileNameList: [],
      filePathList: [],
      headerData: {
        Authorization: localStorage.access_token,
      },
      commissionPercentageListNew: [],
      radio: "",
      rentTypeChange: false,
      wuTitle: "天",
      salesVolumeData: [
        {
          salesLower: "",
          salesUpper: "",
          ratio: "",
          contractId: "",
          id: "",
          shopId: "",
          years: "",
        },
      ],
      historyData: [],
      formRent: {
        salesDate: "",
        num: "",
        money: "",
        fileUrl: ""
        // contractId: 0,
        // shopId: 0
      },
      salesDate: [],
      rentTypShow: false,
      innerVisible: false,
      freeRentRatioList: [
        {
          value: "1",
          label: "全免",
        },
        {
          value: "0.5",
          label: "减半",
        },
      ],
      show2: false, //控制筛选列的多选框
      oneRow: "", //当checkList列表只有一项时,选择框不可点击
      checkList: [
        "新悦合同编号",
        "商户名称",
        "合同编号",
        "商铺编号",
        "经营品牌",
        "装修期物业费",
        "开始日期",
        "到期时间",
        "出租面积",
        "经营业态",
        "装修免租期开始时间",
        "装修免租期结束时间",
        "开业时间",
        "创建时间",
        "合同状态",
        "装修物业费",
        "装修保证金",
        "租金",
        "物业费",
        "推广费",
        "合同计租日",
        "付款周期",
        "履约保证金",
        "经营免租期",
        "租金收取方式",
        "提成比例(营业额)",
        "合同交付日",
        "发票抬头",
        "纳税人识别号",
        "审核状态",
      ],
      drsm: false,
      titleShow: "",
      titleObj: {
        contractCode: "新悦合同编号",
        merchantName: "商户名称",
        contractInCode: "合同编号",
        decorationPropertyFee: "装修期物业费(元)",
        decorationDeposit: "装修保证金(元)",
        rent: "租金(元/㎡*天)",
        shopCode: "商铺编号",
        brandName: "经营品牌",
        propertyFee: "物业费(元/㎡*天)",
        promotionFee: "推广费(元/㎡*月)",
        performanceBond: "履约保证金(元)",
        rentType: "租金收取方式",
        commissionPercentage: "提成比例(营业额)",
        rentBeginDate: "合同计租日",
        deliveryDate: "合同交付日",
        paymentCycleRent: "租金付款周期(自然月)",
        paymentCycleWuye: "物业付款周期(自然月)",
        beginDate: "开始日期",
        endDate: "到期时间",
        rentalArea: "出租面积",
        shopFormat: "经营业态",
        decoFreeRentBegin: "装修免租期开始时间",
        decorationFreeRent: "装修免租期结束时间",
        openFreeRentTimeSimplifyStr: "经营免租期",
        openDate: "开业时间",
        createTime: "创建时间",
        status: "合同状态",
        flag: "备注",
        invoiceHand: "发票抬头",
        dutyParagraph: "纳税人识别号",
        result: "审核状态",
        person: "联系人",
        personPhone: "联系电话",
      },
      oldTitleObj: "",
      totalNum: null,
      info: {
        id: "",
        isAgreement: "0",
        contractCode: "", //新悦合同编号
        openDate: "", //开业时间
        contractInCode: "", //合同编号
        result: "未审核", //审核状态
        status: "启用", //合同状态
        decorationPropertyFee: "", //装修期物业费(元)
        merchantName: "", //商户名称
        decorationDeposit: "", //装修保证金(元)
        shopCode: "", //商铺编号
        rentType: "固定租金", //租金收取方式
        commissionPercentage: "", //租金文本
        rent: "", //租金固定（元/天）
        paymentCycleRent: "", //付款周期(自然月)
        paymentCycleWuye: "", //付款周期(自然月)
        shopFormat: "", //经营业态
        brandName: "", //经营品牌
        propertyFee: "", //物业费
        rentBeginDate: "", //合同计租日
        deliveryDate: "", //合同交付日
        promotionFee: "", //推广费
        beginDate: "", //开始日期
        endDate: "", //结束日期
        // rentBeginDate: "",//合同计租日
        performanceBond: "", //履约保证金
        decoFreeRentBegin: "", //装修免租期开始时间
        decorationFreeRent: "", //装修免租截止日期
        invoiceHand: "", //发票抬头：
        dutyParagraph: "", //纳税人识别号
        freeRentRatio: "", //免租率
        person: "", //联系人
        personPhone: "", //联系电话
      },
      propertyFeeType: false,
      headers: {
        Authorization: localStorage.access_token,
      },
      openFreeRentTime: [],
      formInline: {
        isAgreement: null,
        contractCode: null,
        merchantName: null,
        shopCode: null,
        status: null,
        result: null,
        beginDate: null,
        endDate: null,
        page: 1,
        rows: 10,
      },
      data: [],
      title: "",
      show: false,
      roleId: null,
      isSh: false,
      bn: false,
      isCK: false,
      isFail: false,
      czList: [],
      qsList: [],
      tj: {},
      yearList: [],
      yearNow: "",
      commissionPercentageList: [],
      rentList: [],
      rentNow: "",
      commissionPercentageNow: "",
    };
  },
  computed: {  
  uniqueShopList() {  
    return this.shopListSelect.filter((item, index, self) => {  
      return self.findIndex(t => t.brandName === item.brandName) === index;  
    });  
  },
  uniqueShopNumList() {  
    return this.shopList.filter((item, index, self) => {  
      return self.findIndex(t => t.shopCode === item.shopCode) === index;  
    });  
  }    
},
  watch: {
    yearNow: function (val) {
      this.rentNow = this.rentList[val];
      this.commissionPercentageNow = this.commissionPercentageList[val];
    },
    rentNow: function (val) {
      this.rentList[this.yearNow] = val;
    },
    commissionPercentageNow: function (val) {
      this.commissionPercentageList[this.yearNow] = val;
    },
    "info.rentType": function (val) {
      this.changeType();
    },
    "info.endDate": function (val) {
      this.changeType();
    },
    "info.beginDate": function (val) {
      this.changeType();
    },
    propertyFeeType: function (val) {
      if (val) {
        this.wuTitle = "月";
      } else {
        this.wuTitle = "天";
      }
    },
  },
  mounted() {
    this.oldTitleObj = JSON.parse(JSON.stringify(this.titleObj));
    (this.checkList = [
      "商户名称",
      "合同编号",
      "租金(元/㎡*天)",
      "商铺编号",
      "经营品牌",
      "开始日期",
      "到期时间",
      "出租面积",
      "经营业态",
      "装修免租期开始时间",
      "装修免租期结束时间",
      "租金收取方式",
      "开业时间",
      "审核状态",
    ]),
      (this.titleObj = {
        // contractCode: "新悦合同编号",
        merchantName: "商户名称",
        contractInCode: "合同编号",
        shopCode: "商铺编号",
        brandName: "经营品牌",
        rent: "租金(元/㎡*天)",
        beginDate: "开始日期",
        endDate: "到期时间",
        rentalArea: "出租面积",
        shopFormat: "经营业态",
        decoFreeRentBegin: "装修免租期开始时间",
        decorationFreeRent: "装修免租期结束时间",
        rentType: "租金收取方式",
        openDate: "开业时间",
        // createTime: "创建时间",
        status: "合同状态",
        result: "审核状态",
      });
    this.roleId = localStorage.roleId;
    this.getShopList();
    this.getAll();
  },
  methods: {
    mindUnput(row) {
      if (row.entryDay) {
        var startDate = Date.parse(row.entryDay);
        console.log(row.entryDay);

        var endDate = Date.parse(new Date());
        var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        if (days > 15) {
          return "color:red";
        } else {
          return "";
        }
      } else {
        return "color:red";
      }
    },
    getShopList() {
      let selectForm = {
        contractCode: null,
        merchantName: null,
        shopCode: null,
        status: null,
        result: "",
        beginDate: null,
        endDate: null,
        page: 1,
        rows: 100000,
      };
      this.$http.post("/api/newContract/select", selectForm).then((res) => {
        this.shopList = res.data.data.items;
        this.shopListSelect = res.data.data.items;
      });
    },
    handleDateChange(value) {  
      // value 是一个包含开始日期和结束日期的对象        
      if (value) { 
        // alert(value); 
        if (this.info.commissionPercentage) {
        //alert(this.info.commissionPercentage);
        this.commissionPercentageListNew = this.info.commissionPercentage.split("#");
        var endDate = new Date(value.slice(",")[0]);
        // alert(endDate);
        var startDate = new Date(this.info.beginDate);
        // 获取年份、月份和日期  
        var startYear = startDate.getFullYear();  
        var startMonth = startDate.getMonth();  
        var startDay = startDate.getDate();  
      
        var endYear = endDate.getFullYear();  
        var endMonth = endDate.getMonth();  
        var endDay = endDate.getDate();  
      
        // 计算年份差  
        var yearDiff = endYear - startYear;  
      
    // 如果结束日期的月份和日期小于开始日期的月份和日期，则年份差减一  
    if (endMonth < startMonth || (endMonth === startMonth && endDay < startDay)) {  
        yearDiff--;  
    }  

        if(this.commissionPercentageListNew.length>=yearDiff){
          this.radio = this.commissionPercentageListNew[yearDiff];
        }else{
          this.radio = this.commissionPercentageListNew[0];
        }
      }
      this.getList(); //
      this.rentTypShow = true;
      }
    },
    changeNum() {
      if (this.formRent.num) {
        if (this.radio.indexOf("；") == -1) {
          let arr = this.radio.split("：");
          this.formRent.money = (
            parseFloat(this.formRent.num) * parseFloat(arr[1].split("%")[0] / 100)
          ).toFixed(2);
        } else {
          let string = this.radio.split("：")[1];
          let arr = string.split("；");
          let arr2 = [];
          arr.forEach((s) => {
            let stringS = "";
            for (const key in s) {
              if (!isNaN(Number(s[key]))) {
                stringS = stringS + s[key];
              } else if (
                stringS != "" &&
                stringS.slice(stringS.length - 1, stringS.length) != "，"
              ) {
                stringS = stringS + "，";
              }
              // console.log(stringS.slice(stringS.length-1,1))
              //key为索引,s[key]为值,typeof key 为string
            }
            arr2.push(stringS.split("，"));
          });
          let baifen = "";
          let index1 = -1;
          arr2.forEach((element, index) => {
            if (element.length < 4) {
              if (string.indexOf("万") != -1) {
                element[0] = element[0] + "0000";
              }
              if (
                parseFloat(this.formRent.num) <= parseFloat(element[0]) &&
                index1 == -1 &&
                index == 0
              ) {
                index1 = index;
                baifen = element[element.length - 2];
              } else if (
                parseFloat(this.formRent.num) > parseFloat(element[0]) &&
                index1 == -1 &&
                index == arr2.length - 1
              ) {
                index1 = index;
                baifen = element[element.length - 2];
              }
            } else {
              if (string.indexOf("万") != -1) {
                element[0] = element[0] + "0000";
                element[1] = element[1] + "0000";
              }
              if (
                parseFloat(this.formRent.num) > Number(element[0]) &&
                parseFloat(this.formRent.num) <= Number(element[1]) &&
                index1 == -1
              ) {
                index1 = index;
                baifen = element[element.length - 2];
              }
            }
          });
          this.formRent.money = (
            parseFloat(this.formRent.num) * parseFloat(baifen / 100)
          ).toFixed(2);
        }
        this.$forceUpdate();
      }
    },
    down(name, url) {
      window.open(url);
      // window.location.href = url
      // let a = document.createElement('a')
      // a.href = url;
      // a.click();
    },
    delUrl(index) {
      this.fileNameList.splice(index, 1);
      this.filePathList.splice(index, 1);
      this.fileList.splice(index, 1);
    },
    beforeUpload(file, fileList) {
      // console.log(file.name.split(".")[0])
      // console.log(this.fileList)
      let status = true;
      this.fileNameList.forEach((element) => {
        if (file.name.split(".")[0] == element) {
          status = false;
        }
      });
      if (!status) {
        this.$message.error(`${file.name.split(".")[0]}文件已存在！`);
      }
      return status;
    },
    onSuccess(response, file, fileList) {
      // this.detailFileList(fileList);
      if (response.code == "0") {
        // this.form.filePath = fileList[0].response.data.filePath;
        // this.form.fileName = fileList[0].response.data.fileName;
        this.fileNameList.push(file.name.split(".")[0]);
        this.filePathList.push(response.data);
        this.fileList.push({
          name: file.name.split(".")[0],
          url: response.data,
        });
        // this.form.files = [res.data]
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");
      }
    },
    addJYMZQ() {
      let data = {
        start: "",
        end: "",
        freeRentRatio: 1,
        datePeriod: "",
        dateValue: [],
      };
      this.openFreeRentTime.push(data);
    },
    delJYMZQ() {
      if (this.openFreeRentTime.length > 0) {
        this.openFreeRentTime.splice(this.openFreeRentTime.length - 1, 1);
      }
    },
    addBtu() {
      this.info = {
        id: "",
        isAgreement: "0",
        contractCode: "", //新悦合同编号
        openDate: "", //开业时间
        contractInCode: "", //合同编号
        result: "未审核", //审核状态xz
        status: "启用", //合同状态
        decorationPropertyFee: "", //装修期物业费(元)
        merchantName: "", //商户名称
        decorationDeposit: "", //装修保证金(元)
        shopCode: "", //商铺编号
        rentType: "固定租金", //租金收取方式
        commissionPercentage: "", //租金文本
        rent: "", //租金固定（元/天）
        paymentCycleRent: "", //付款周期(自然月)
        paymentCycleWuye: "", //付款周期(自然月)
        shopFormat: "", //经营业态
        brandName: "", //经营品牌
        propertyFee: "", //物业费
        rentBeginDate: "", //合同计租日
        deliveryDate: "", //合同交付日
        promotionFee: "", //推广费
        beginDate: "", //开始日期
        endDate: "", //结束日期
        // rentBeginDate: "",//合同计租日
        performanceBond: "", //履约保证金
        decoFreeRentBegin: "", //装修免租期开始时间
        decorationFreeRent: "", //装修免租截止日期
        invoiceHand: "", //发票抬头：
        dutyParagraph: "", //纳税人识别号
        freeRentRatio: "", //免租率
        person: "", //联系人
        personPhone: "", //联系电话
      };
      this.isSh = false;
      this.show = true;
      this.bn = true;
      this.isCK = false;
      this.openFreeRentTime = [];
      this.titleShow = "新增";
    },
    addSalesVolumeData() {
      this.salesVolumeData.push({
        salesLower: "",
        salesUpper: "",
        ratio: "",
        contractId: this.info.id,
        shopId: "",
        id: "",
        years: this.yearNow + 1,
      });
    },
    delSalesVolumeData(index, row) {
      if (this.salesVolumeData.length == 1) {
        this.$message({
          type: "info",
          message: "至少需要一条比例",
        });
      } else {
        this.salesVolumeData.splice(index, 1);
      }
    },

    exportData() {
      let arr = this.checkList;
      let index = arr.indexOf("导出招商合同");
      if (index != -1) {
        arr[index] = "是";
      }
      publicExport(
        "/api/newContract/exportZsContract",
        {
          ...this.formInline,
          heads: arr,
        },
        "招商合同列表"
      );
    },
    checkChange(val) {
      //筛选列复选框被改变
      // val.forEach(val=>{
      // 	if(val=='')
      // })
      var newObj = {};
      for (var key in this.oldTitleObj) {
        if (val.indexOf(this.oldTitleObj[key]) != -1) {
          newObj[key] = this.oldTitleObj[key];
        }
      }
      this.titleObj = newObj;
      if (val.length == 1) {
        //只有一列时,复选框禁止勾选
        this.oneRow = val[0];
        this.$message.warning("表格内容至少显示一列");
        return;
      }
      this.oneRow = "";
    },
    addTemplate() {
      //下载导入模板
      this.$http
        .post(
          `/api/newContract/download`,
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=utf-8",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "招商合同导入模板.xls";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    ty2(row) {
      this.$confirm("确定停用该合同, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .get("/api/newContract/approve", {
              params: {
                id: row.id,
                result: "停用",
              },
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
              }

              this.getAll();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    ty(value) {
      this.$http
        .get("/api/newContract/approve", {
          params: {
            id: this.info.id,
            result: value,
          },
        })
        .then((res) => {
          this.show = false;
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }

          this.getAll();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    ckRow(val) {
      this.show = true;
      this.isSh = true;
      this.isCK = true;
      this.titleShow = "查看";
      this.info = {
        ...val,
      };
      // this.querySalesVolumeData(val.id);//查询销售提成数据

      this.setOther(val);
    },
    shRow(val) {
      this.show = true;
      this.isSh = true;
      this.isCK = false;
      this.titleShow = "审核";
      this.info = {
        ...val,
      };
      // this.querySalesVolumeData(val.id);//查询销售提成数据

      this.setOther(val);
    },
    error(res) {
      this.$message.success("导入失败");
    },
    success(res) {
      if (res.code == 0) {
        this.getAll();
        this.$message.success("导入成功");
      } else if (res.code == 500) {
        this.$message.error("导入失败，请使用模版导入！");
      } else {
        this.$message.error(res.message);
        this.isFail = true;
        this.czList = res.data.已经存在的记录;
        this.qsList = res.data.缺失字段的记录;
      }
    },
    uploadDown(obj) {
      this.$confirm("确定下载该文件吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          downloadFile(obj);
          this.$message({
            type: "success",
            message: "下载成功!",
          });
        })
        .catch((err) => {
          this.$message({
            type: "success",
            message: "取消下载!",
          });
        });
    },
    delRow(val) {
      var id = val.id;

      this.$confirm("确定删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http.get(`/api/newContract/id?id=${id}`).then((res) => {
            this.$message({
              type: "success",
              message: res.data.message,
            });
            this.getAll();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    sizeChange(size) {
      //页大小被修改
      this.formInline.rows = size;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      this.formInline.page = page;
      this.getAll();
    },
    // 表格总计的时间
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        //this.closeList等等是后台返回的总的数据，然后取值到这里
        switch (column.property) {
          case "decorationPropertyFee":
            sums[index] = this.tj.装修期物业费汇总;
            break;
          case "decorationDeposit":
            sums[index] = this.tj.装修保证金汇总;
            break;
          case "rent":
            sums[index] = this.tj.租金汇总;
            break;
          case "promotionFee":
            sums[index] = this.tj.推广费汇总;
            break;
          case "performanceBond":
            sums[index] = this.tj.履约保证金汇总;
            break;
          case "rentalArea":
            sums[index] = this.tj.出租面积汇总;
            break;
          case "propertyFee":
            sums[index] = this.tj.物业费汇总;
            break;
          default:
            break;
        }
      });

      return sums;
    },
    query() {
      this.formInline.page = 1;
      this.getAll();
    },
    getAll() {
      this.$http
        .post("/api/newContract/select", {
          ...this.formInline,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.data = res.data.data.items;

            this.totalNum = res.data.data.totalNum;
            this.tj = res.data.data.map;
          } else {
            this.totalNum = 0;
            this.data = [];
          }
        });
    },
    dc() {},
    getRow(val) {},
    changeType() {
      let year = this.info.endDate.split("-")[0] - this.info.beginDate.split("-")[0];
      this.yearList = [];
      // this.rentList = []
      // this.commissionPercentageList = []
      // this.rentNow = ""
      this.commissionPercentageNow = "";
      for (let i = 1; i <= year; i++) {
        this.yearList.push({
          id: i - 1,
          year: `第${i}年`,
        });
        if (i > this.rentList.length) {
          this.rentList.push("");
          this.commissionPercentageList.push("");
        }
      }
      this.yearNow = this.yearList[0].id;
    },
    setRow(val) {
      this.isSh = false;
      this.show = true;
      this.bn = true;
      this.isCK = false;
      this.titleShow = "修改";
      this.info = {
        ...val,
      };
      if (this.info.deadRent) {
        this.rentTypeChange = true;
      } else {
        this.rentTypeChange = false;
      }
      // this.querySalesVolumeData(val.id);//查询销售提成数据

      this.setOther(val);

      return;
      // this.$http.get(`/api/salesVolume/queryByContractId?contractId=${val.id}`).then(res => {

      // 	if (res.data.code == 0) {
      // 		this.salesVolumeData = res.data.data;
      // 	}

      // })
    },
    setOther(val) {
      if (val.propertyFeeType == "月") {
        this.propertyFeeType = true;
      } else {
        this.propertyFeeType = false;
      }
      this.yearList = [];
      // if (val.yearRent) {
      // 	let arr = val.yearRent.split(",")
      // 	this.rentList = arr
      // 	for (let i = 1; i <= arr.length; i++) {
      // 		this.yearList.push({
      // 			id: i - 1,
      // 			year: `第${i}年`,
      // 		})

      // 	}
      // 	this.yearNow = this.yearList[0].id
      // 	this.rentNow = this.rentList[0]
      // } else {
      // 	this.rentList = []
      // 	this.rentNow = "";
      // 	this.yearNow = "";
      // 	this.changeType();
      // }
      //  console.log(val.openFreeRentTime)
      if (val.openFreeRentTime) {
        let strJson = JSON.parse(val.openFreeRentTime);
        console.log(strJson);
        strJson.forEach((element) => {
          element.dateValue = [];
        });
        this.openFreeRentTime = strJson;
        this.openFreeRentTime.forEach((element) => {
          element.dateValue = [element.start, element.end];
        });
      } else {
        this.openFreeRentTime = [];
      }
    },
    formatDateTime(date) {
      var date = new Date(date);
      var timeStr = date.getFullYear() + "-";
      if (date.getMonth() < 9) {
        //月份从0开始的
        timeStr += "0";
      }
      timeStr += date.getMonth() + 1 + "-";
      timeStr += date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      //   timeStr += ' ';
      //   timeStr += date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours();
      //   timeStr += ':';
      //   timeStr += date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
      //   timeStr += ':';
      //   timeStr += date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds();
      return timeStr;
    },
    resetForm() {
      this.formRent.money = "";
      this.formRent.num = "";
      this.radio = "";
      this.salesDate = [];
      this.fileNameList = [];
      this.filePathList = [];
      this.fileList = [];
      this.commissionPercentageListNew = [];
    },
    viewSalesVolume(obj) {
      if (obj) {
        this.info = {
          ...obj,
        };
      }
      this.resetForm();
      // this.$http.get(`/api/salesVolume/queryByContractId?contractId=${this.info.id}&years=${this.yearNow + 1}`).then(res => {
      // 	if (res.data.code == 0) {
      // 		this.salesVolumeData = res.data.data;
      // 	}
      // })

      if (this.info.commissionPercentage) {
        //alert(this.info.commissionPercentage);
        this.commissionPercentageListNew = this.info.commissionPercentage.split("#");
        var endDate = new Date();
        var startDate = new Date(this.info.beginDate);
        // 获取年份、月份和日期  
        var startYear = startDate.getFullYear();  
        var startMonth = startDate.getMonth();  
        var startDay = startDate.getDate();  
      
        var endYear = endDate.getFullYear();  
        var endMonth = endDate.getMonth();  
        var endDay = endDate.getDate();  
      
        // 计算年份差  
        var yearDiff = endYear - startYear;  
      
    // 如果结束日期的月份和日期小于开始日期的月份和日期，则年份差减一  
    if (endMonth < startMonth || (endMonth === startMonth && endDay < startDay)) {  
        yearDiff--;  
    }  

        if(this.commissionPercentageListNew.length>=yearDiff){
          this.radio = this.commissionPercentageListNew[yearDiff];
        }else{
          this.radio = this.commissionPercentageListNew[0];
        }
      }
      this.getList(); //
      this.rentTypShow = true;
    },
    ok() {
      this.info.rentList = [];
      this.info.commissionPercentageList = [];
      if (this.info.rentType == "固定租金") {
        if (!this.info.rent) { 
          if(this.info.deadRent){    
            this.rentTypeChange = true;        
            this.info.rent = 0;
          }else{
            this.$message.warning('请填写租金');
          }
        }
      }
      let arr = [];
      this.openFreeRentTime.forEach((element) => {
        let data = {
          start: element.dateValue[0],
          end: element.dateValue[1],
          freeRentRatio: element.freeRentRatio,
          datePeriod:
            this.formatDateTime(element.dateValue[0]) +
            "/" +
            this.formatDateTime(element.dateValue[1]),
        };
        arr.push(data);
      });
      if (arr.length > 0) {
        this.info.openFreeRentTime = JSON.stringify(arr);
      } else {
        this.info.openFreeRentTime = null;
      }
      if (this.propertyFeeType) {
        this.info.propertyFeeType = "月";
      } else {
        this.info.propertyFeeType = "";
      }
      if (this.info.id) {
        this.$http
          .put("/api/newContract", {
            ...this.info,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.show = false;
              this.$message.success(res.data.message);
              this.getAll();
            }
          });
      } else {
        this.$http
          .post("/api/newContract", {
            ...this.info,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.show = false;
              this.$message.success(res.data.message);
              this.getAll();
            }
          });
      }
    },
    querySalesVolumeData(id) {
      this.$http
        .get(
          `/api/salesVolume/queryByContractId?contractId=${this.info.id}&years=${
            this.yearNow + 1
          }`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.salesVolumeData = res.data.data;
          }
        });
    },
    saveSalesVolume(id) {
      let data = {
        contractId: this.info.id,
        entities: this.salesVolumeData,
        totalYears: this.yearList.length,
        years: this.yearNow + 1,
      };

      this.$http.post("/api/salesVolume/saveAll", data).then((res) => {
        if (res.data.code == 0) {
          // this.innerVisible = false;
        }
      });
    },
    delRentType(index, row) {
      this.$http.delete(`/api/bdShop/deleteRentalEntry?id=${row.id}`).then((res) => {
        if (res.data.code == 0) {
          this.getList();
          this.$message.success("删除成功！");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    outRentType(index, row) {
      this.$http
        .post("/api/shopSalesVolume/billGenerate", {
          contractId: this.info.id,
          id: row.id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success("账单生成成功！");
          } else {
            this.$message.error(res.data.message);
          }
        });
    },

    rentSubmit() {
      // console.log(this.info)
      // return
      if (this.radio == "") {
        this.$message.error("请选择租金计算规则");
        return;
      }
      if (this.salesDate.length != 2) {
        this.$message.error("请选择时间");
        return;
      }
      if (this.formRent.num == "") {
        this.$message.error("请输入营业额");
        return;
      }
      if (this.formRent.money == "") {
        this.$message.error("请完善租金");
        return;
      }
      // this.formRent.contractId = this.info.id;
      // this.formRent.shopId = this.info.shopId;
      this.$http
        .post("/api/bdShop/changeRentalEntry", {
          salesDate: this.salesDate[0] + "~" + this.salesDate[1],
          num: this.formRent.num,
          money: this.formRent.money,
          shopCode: this.info.shopCode,
          updateName: sessionStorage.getItem("name"),
          accessoryName: this.fileNameList.toString(),
          accessory: this.filePathList.toString(),
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.resetForm();
            this.$message.success("保存成功");
            this.getList();
            this.calculateDifference(this.info.shopCode);
          } else {
            this.$message.error(res.data.message);
          }
        });
      // this.$http.post("/api/shopSalesVolume/save", {
      // 	...this.formRent
      // }).then(res => {
      // 	if (res.data.code == 0) {
      // 		this.queryShopSalesVolumeData(this.formRent.contractId);
      // 	} else {
      // 		this.$message.error(res.data.message);
      // 	}
      // })
    },
    getList() {
      this.$http
        .get("/api/bdShop/getRentalEntry?shopNum=" + this.info.shopCode)
        .then((res) => {
          if (res.data.code == 0) {
            this.historyData = res.data.data;
            this.historyData.forEach((element) => {
              element.fileList = [];
              let arr = element.accessoryName.split(",");
              let arr2 = element.accessory.split(",");
              arr.forEach((item, index) => {
                element.fileList.push({ name: item, url: arr2[index] });
              });
            });
          } else {
            // this.$message.error(res.data.message);
          }
        });
    },
    queryShopSalesVolumeData(id) {
      this.$http
        .get(`/api/shopSalesVolume/queryByContractId?contractId=${id}`)
        .then((res) => {
          if (res.data.code == 0) {
            this.historyData = res.data.data;
          }
        });
    },
  },
};
</script>

<style scoped="scoped"></style>
